import React from 'react';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';

import FieldTextBox from './FieldTextBox.jsx';

export default class TrackRating extends React.Component {
  render() {
    const { num } = this.props;

    return (
      <>
        <h4 className="rating-type">Track {num}</h4>
        <Row>
          <Col xs={12} sm={6}>
            <FieldTextBox placeholder="Track" field={`track${num}Name`} />
          </Col>
          <Col xs={12} sm={6}>
            <FieldTextBox placeholder="Target Lap" field={`track${num}TargetLap`} />
          </Col>
        </Row>
        <Row>
          {_.map(_.times(10), i => (
            <Col key={i} xs={12} sm={6}>
              <FieldTextBox placeholder={`Run ${i + 1}`} field={`track${num}Run${i + 1}`} />
            </Col>
          ))}
        </Row>
      </>
    );
  }
}
